import React, { useState } from "react";
import { FaShieldAlt, FaExchangeAlt, FaMinus, FaPlus, FaChartLine, FaFileMedical, FaChartPie, FaBrain, FaDatabase, FaClipboardCheck, FaUserMd, FaHospitalUser, FaUsers, FaFileAlt, FaCog, FaMicroscope, FaMoneyBillWave, FaClock, FaDna } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const HDA = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">Advanced Healthcare Data Analytics</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At HIKEHEALTH Gs, We provide AI-powered healthcare data analytics solutions to help hospitals, clinics, and health tech companies process, analyze, and visualize medical data for better decision-making and patient care.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                        initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Predictive Analytics",
        description: "Leverage AI models to forecast patient outcomes, disease trends, and resource utilization.",
        icon: FaChartLine
    },
    {
        title: "AI-Powered Diagnostics",
        description: "Utilize machine learning for early disease detection and precision medicine insights.",
        icon: FaBrain
    },
    {
        title: "Patient Population Insights",
        description: "Analyze demographic and clinical data to enhance patient care strategies.",
        icon: FaHospitalUser
    },
    {
        title: "Big Data Integration",
        description: "Consolidate and process data from EHRs, medical devices, and lab systems in real time.",
        icon: FaDatabase
    },
    {
        title: "Clinical Decision Support",
        description: "Empower healthcare providers with AI-driven recommendations and real-time alerts.",
        icon: FaUserMd
    }
];



const services = [

    {
        title: "Predictive Analytics",
        description: "Use machine learning to forecast patient outcomes, disease risks, and resource utilization.",
        icon: FaChartLine
    },
    {
        title: "Population Health Management",
        description: "Analyze demographic and clinical data to improve public health strategies.",
        icon: FaUsers
    },
    {
        title: "EHR Data Integration",
        description: "Aggregate data from EHRs, medical devices, and IoT wearables for a comprehensive view.",
        icon: FaFileMedical
    },
    {
        title: "Clinical Decision Support",
        description: "Leverage real-time analytics to assist providers with diagnosis and treatment recommendations.",
        icon: FaBrain
    },
    {
        title: "Revenue Cycle & Financial Analytics",
        description: "Optimize medical billing, claims processing, and reimbursement workflows with data insights.",
        icon: FaMoneyBillWave
    },
    {
        title: "Operational & Workflow Optimization",
        description: "Enhance hospital performance, resource allocation, and patient flow management.",
        icon: FaCog
    },
    {
        title: "AI-Powered Diagnostics",
        description: "Utilize image recognition, NLP, and big data analytics for precision medicine.",
        icon: FaMicroscope
    },
    {
        title: "Regulatory Compliance & Reporting",
        description: "Ensure HIPAA, HL7, FHIR, and GDPR compliance with automated reports and dashboards.",
        icon: FaClipboardCheck
    }
];

const whyChooseUs = [
    {
        title: "AI-Driven Insights",
        description: "Advanced data science, machine learning, and deep learning techniques for actionable insights.",
        icon: FaBrain
    },
    {
        title: "Seamless Integration",
        description: "Connect data from EHR systems, IoT devices, PACS, LIS, and cloud platforms.",
        icon: FaExchangeAlt
    },
    {
        title: "Real-Time Data Processing",
        description: "Implement streaming analytics for instant clinical and operational decision-making.",
        icon: FaClock
    },
    {
        title: "Scalable & Secure",
        description: "HIPAA-compliant cloud-based analytics solutions with robust data protection measures.",
        icon: FaShieldAlt
    },
    {
        title: "Custom Dashboards & Reporting",
        description: "Tailored interactive visualizations for healthcare professionals and administrators.",
        icon: FaChartPie
    }
];

const List = [
    {
        title: "Healthcare Business Intelligence",
        description: "Transform raw data into actionable business and clinical insights.",
        icon: FaDatabase
    },
    {
        title: "AI-Powered Patient Risk Stratification",
        description: "Identify high-risk patients for early intervention and personalized treatment.",
        icon: FaUserMd
    },
    {
        title: "Big Data Analytics for Genomics & Precision Medicine",
        description: "Process genetic data for personalized healthcare solutions.",
        icon: FaDna
    },
    {
        title: "Natural Language Processing (NLP) in Healthcare",
        description: "Extract insights from clinical notes, EHRs, and unstructured data sources.",
        icon: FaFileAlt
    },
    {
        title: "Healthcare Fraud Detection",
        description: "Use AI models to identify billing fraud, insurance claims anomalies, and financial risks.",
        icon: FaShieldAlt
    }
];



export default HDA;
